import React from "react";
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Skeleton,
} from "@mui/material";

const SentimentDriversTable = ({
  data = [],
  loading = false,
  error = null,
  title = "",
  maxHeight = 700,
  id = null
}) => {
  const isStringArray = data.length > 0 && typeof data[0] === "string";
  const normalizedData = isStringArray
    ? data.map((item) => ({ Name: item }))
    : data;

  normalizedData.sort((a, b) => {
    const signalA = parseInt(a["Signal Strength"]);
    const signalB = parseInt(b["Signal Strength"]);
    return signalB - signalA;
  });

  const columnKeys =
    normalizedData.length > 0 ? Object.keys(normalizedData[0]) : [];

  const LoadingSkeleton = () => (
    <div className="p-3">
      <Skeleton variant="rectangular" height={30} />
      {Array(10)
        .fill(0)
        .map((_, rowIndex) => (
          <div
            key={rowIndex}
            style={{ display: "flex", gap: "1rem", marginTop: 10 }}
          >
            {columnKeys.map((_, colIndex) => (
              <Skeleton
                variant="rectangular"
                width={`${90 / columnKeys.length}%`}
                height={20}
                key={colIndex}
              />
            ))}
          </div>
        ))}
    </div>
  );

  const formatHeader = (key) =>
    key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());

  return (
    <Card sx={{ m: 3, boxShadow: 3, borderRadius: 4 }} id={id}>
      <p></p>
      <Typography variant="h6" align="center" gutterBottom>
        {title}
      </Typography>

      {loading && !error && <LoadingSkeleton />}

      {!loading && !error && normalizedData?.length > 0 && (
        <CardContent sx={{ padding: 0 }}>
          <TableContainer
            component={Paper}
            elevation={0}
            sx={{
              maxHeight: maxHeight,
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <Table
              stickyHeader
              sx={{
                minWidth: "100%",
                tableLayout: "fixed",
              }}
              aria-label="dynamic table"
            >
              <TableHead>
                <TableRow>
                  {columnKeys.map((colKey, index) => (
                    <TableCell
                      key={index}
                      align="center"
                      sx={{
                        backgroundColor: "#4fd1c5",
                        color: "#fff",
                        fontWeight: 600,
                        position: "sticky",
                        top: 0,
                        zIndex: 1,
                      }}
                    >
                      {formatHeader(colKey)}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {normalizedData.map((row, rowIndex) => (
                  <TableRow
                    key={rowIndex}
                    sx={{
                      backgroundColor:
                        rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff",
                    }}
                  >
                    {/* {columnKeys.map((colKey, colIndex) => (
                      <TableCell
                        key={colIndex}
                        align="center"
                        sx={{
                          wordBreak: "break-word", // wrap long words
                          whiteSpace: "normal", // allow wrapping
                        }}
                      >
                        {row[colKey] ?? "--"}
                      </TableCell>
                    ))} */}

                    {columnKeys.map((colKey, colIndex) => {
                      const isLast = colIndex === columnKeys.length - 1;
                      const baseWidth = `${100 / (columnKeys.length + 1)}%`;
                      const cellWidth = isLast
                        ? `calc(${baseWidth} * 2)`
                        : baseWidth;

                      return (
                        <TableCell
                          key={colIndex}
                          align="center"
                          sx={{
                            wordBreak: "break-word",
                            whiteSpace: "normal",
                            width: cellWidth,
                          }}
                        >
                          {row[colKey] ?? "--"}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      )}
    </Card>
  );
};

export default SentimentDriversTable;
